/**
 * Converte as coordenadas ReportLab dos layouts para dentro da etiqueta
 * (origem no canto superior esquerdo do recorte LABEL_BOX).
 */
import { MONTSERRAT_ASCENT, PAGE } from "./layout/constants";
import { LABEL_BOX } from "./labelAssets";

/** y ReportLab (sobe) → top da página (desce). */
const rlTop = (yFromBottom, height = 0) => PAGE.height - yFromBottom - height;

/** Texto: y ReportLab é a baseline; o topo da caixa fica um ascender acima. */
const textPos = (layout, fontSize) => ({
  left: layout.x - LABEL_BOX.left,
  top: rlTop(layout.y, MONTSERRAT_ASCENT * fontSize) - LABEL_BOX.top,
});

/** Caixa: y ReportLab é o canto inferior esquerdo. */
const boxPos = (layout) => ({
  left: layout.x - LABEL_BOX.left,
  top: rlTop(layout.y, layout.height || 0) - LABEL_BOX.top,
  width: layout.width,
  height: layout.height,
});

/** Centro X de um elemento centralizado, relativo à etiqueta. */
const centerX = (absoluteCenterX) => absoluteCenterX - LABEL_BOX.left;

export { rlTop, textPos, boxPos, centerX };
